import { messages } from '@scantrust/st-gallery'
import de from './de.json'
import en from './en.json'
import es from './es.json'
import fr from './fr.json'
import it from './it.json'
import nl from './nl.json'
import zh from './zh.json'
import pt from './pt.json'
import languagesEn from './shared/languages/en.json'

export default {
  messages: {
    en: {
      ...en,
      ...languagesEn,
      ...messages.en
    },
    fr: {
      ...fr,
      ...messages.fr
    },
    de: {
      ...de,
      ...messages.de
    },
    es: {
      ...es,
      ...messages.es
    },
    it: {
      ...it,
      ...messages.it
    },
    nl: {
      ...nl,
      ...messages.nl
    },
    zh: {
      ...zh,
      ...messages.zh
    },
    pt: {
      ...pt,
      ...messages.pt
    }
  }
}
